module.exports = __webpack_public_path__ + "img/202MG_MGC_MGD.bc2efc29.png";